import * as React from 'react';
import { UserTypes } from '../Auth/store/types';

export type ComponentType = React.ElementType | React.ComponentType;

export enum RoutesModules {
  ADMIN = "Admin",
  AGENCIES = "Agencies",
  ALERTS = "Alerts",
  CASES = "Cases",
  COMMON = "Common",
  DASHBOARD = "Dashboard",
  GEOSEARCH = "PDTR",
  HELP = "Help",
  NEWS = "News",
  PUBLIC = "Public",
  SEARCH = "Search",
  SETTINGS = "Settings"
}

export interface IRouteAuth {
  authorized: boolean,
  private: boolean,
  forbidden?: boolean
}

export interface ILinkedRoute {
  key: string
  component: ComponentType
  path: string[]
  policies: UserTypes[]
  module: string
  showNavBar: boolean
}
export interface ICurrentRoute {
  path: string[]
  showNavBar: boolean
}

export interface ISideBar {
  isFormLink?: boolean;
  navTitle: string;
  path?: string;
  route: string;
  hideOnMobile?: boolean;
  isMainPath?: boolean;
  modulePath?: string;
}

export interface IRoutes {
  paths: string[]
  component: ComponentType
  policies: UserTypes[]
  hideNavBar?: boolean
}
export interface IRouteModule {
  routes: IRoutes[],
  name: RoutesModules
  settingsNavbar?: boolean
  navbar?: string,
  sidebar?: ISideBar[]
}

export interface INavLink {
  module: RoutesModules,
  route: string,
  sidebar?: ISideBar[]
}
export interface INavLinks {
  settings: INavLink[],
  body: INavLink[]
}
export type RoutePathsFn = (UserTypes?: UserTypes) => IRoutes[]
export type RouteModuleFn = (userType?: UserTypes) => IRouteModule



// WEBPACK FOOTER //
// ./src/modules/Routing/types.ts